// Actions
export const UNIT_FETCH  = '[Unit] Fetch'

// Mutations
export const UNIT_META   = '[Unit] meta'
export const UNIT_OBTAIN = '[Unit] obtain'
export const UNIT_CLEAR  = '[Unit] clear'
export const UNIT_SET_LOADING = '[Unit] set loading'
